import Alpine from "alpinejs";
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import ScrollToPlugin from "gsap/ScrollToPlugin";
import LazyLoad from "vanilla-lazyload";
import { listen } from "quicklink/dist/quicklink.mjs";

import Accordion from "./components/accordion";
import Contentfullscreenblock from "./components/contentfullscreenblock";
import Contentgallery from "./components/contentgallery";
import Entryblock from "./components/entryblock";
import Header from "./components/header";
import Hero from "./components/hero";
import Pagehero from "./components/pagehero";
import Stats from "./components/stats";
import Showcaseblock from "./components/showcaseblock";
import Stepsslider from "./components/stepsslider";
import PageTransition from "./utils/pagetransition";

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

window.Alpine = Alpine;

PageTransition();

window.lazyload = new LazyLoad({
  elements_selector: "[data-lazy]",
});

document.addEventListener("alpine:init", () => {
  Accordion();
  Contentfullscreenblock();
  Contentgallery();
  Entryblock();
  Header();
  Hero();
  Pagehero();
  Stats();
  Showcaseblock();
  Stepsslider();
  listen();
});

// Smooth scroll for anchor links
document.addEventListener("click", (e) => {
  const anchor = e.target.closest('a[href^="#"]');
  if (!anchor) return;
  const target = document.getElementById(anchor.getAttribute("href").slice(1));
  if (!target) return;
  e.preventDefault();
  gsap.to(window, {
    duration: 0.8,
    scrollTo: { y: target, offsetY: 130, autoKill: false },
    ease: "power2.inOut",
  });
});

Alpine.start();
